"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundAccurately = void 0;
function roundAccurately(number, decimalPlaces) {
    // @ts-ignore
    return Number(Math.round(number + 'e' + decimalPlaces) + 'e-' + decimalPlaces);
}
exports.roundAccurately = roundAccurately;
